import React, { Component } from 'react';
import $ from 'jquery';
import ReactDOM from 'react-dom';
import Vas from '../../../Vas';

import '../../../css/VerificationUpload.css';

import { DateTimeHelper,CheckValues } from 'utils-lib';

import { ExtendedButton,TextField,Icon,SelectField,DateField,MessageBox } from 'component-lib';
import {ConfirmationsModel, RequestAjaxClass, CustomerModel} from 'models-lib';

var moment = require('moment');
moment().format();

class VerificationUpload extends Component
{
    constructor(props)
    {
        super(props);
        this.state= {
            whoIsChecked: {
                allowDestroyAll: "true"
            } };
        this.state.files='';
        this.state.fileName='';
        this.state.reference=this;
        
        this.state.CurrentView = "CustomerData";
        this.state.VerificationList=[];
        this.CustomerId = localStorage.getItem('employee_id') ? localStorage.getItem('employee_id'):localStorage.getItem("vas_customerId");
        this.state.Upload=false;

        this.keys = [];
        this.state.from = false;
        this.state.to = false;
        this.state.id = false;
        this.state.description = '';

        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.Request2 = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
        this.ConfirmationsModel = new ConfirmationsModel([this],null,this.Request);
        this.CustomerModel = new CustomerModel([this],null,this.Request2);
                
        this.FileText = React.createRef();
        
        this.VerificationMonthRef = React.createRef();
        this.UploadCertificateRef = React.createRef();

        this.IconConfig = Vas.Config.ShowIconsOrButtons;

        this.UploadConfig = Vas.Config.DocumentUpload;
    }

    componentDidMount(){
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);
        this.Request.setErrorHandler((data)=>{
            $("#LoadingIcon").removeClass().addClass('hide');
        });

        this.Request2.setApiUrl(Vas.ApiUrl);
        this.Request2.setApiKey(Vas.ApiKey);
        this.Request2.setAuth(true);
        
        this.CustomerModel.GetCustomerById(this.CustomerId);

        this.load();
        this.setState({ requiredSelectField:[this.refs.CertificateType] });
    }

    componentDidUpdate(){
        if (this.state.id === true){
            this.refs.IDField.setState({ editable:true });
        } else {
            this.refs.IDField.setState({ editable:false });
        }

        this.LogoClick();
    }

    load(){
        this.ConfirmationsModel.GetAllConfirmations();
    }

    FileUpload() {
        let filled = this.checkFields();
        if (filled === true){
            $("#LoadingIcon").removeClass().addClass('loaderSmall');
        
        let certificationIndex = this.state.CertificationType.indexOf(",");
        let certification = this.state.CertificationType.substring(0,certificationIndex);
        
        let dateFrom = null;
        if (this.state.CertificateStart){
            let cur = DateTimeHelper.StringToDate(this.state.CertificateStart,false,localStorage.getItem('vas_language'));
            dateFrom = moment([cur.year(),cur.month(),cur.date()]).format('YYYY-MM-DD T 00:00:00');
        }

        let dateTo = null;

        if (this.state.CertificateEnd){
            let cur = DateTimeHelper.StringToDate(this.state.CertificateEnd,false,localStorage.getItem('vas_language'));
            dateTo = moment([cur.year(),cur.month(),cur.date()]).format('YYYY-MM-DD T 00:00:00');
        } 

        let ident = null;
        if (this.state.IdentificationNumber){
            ident = this.state.IdentificationNumber;
        } 

        this.ConfirmationsModel.UploadConfirmation(this.CustomerId,certification,dateFrom,dateTo,ident,this.state.files);
        }
    }

    Update(observer)
    {
      let me =this;
        this.setState({},()=>{
          if(observer === "ConfirmationsAll"){
            let verifications = [];
            
            for(let i = 0; i < this.ConfirmationsModel.Confirmations.length; i++){
              let verification = this.ConfirmationsModel.Confirmations[i];
              me.keys.push([verification.Ident ,verification.Name,verification.DateFromAllowed,verification.DateToAllowed,verification.IdentificationNumberAllowed,verification.Description, verification.MinAge, verification.MaxAge]);  
              verifications.push({ Key: [verification.Ident ,verification.Name,verification.DateFromAllowed,verification.DateToAllowed,verification.IdentificationNumberAllowed,verification.Description,  verification.MinAge, verification.MaxAge] , Display: verification.Name });
            }
            
            if (me.refs.CertificateType){
              me.refs.CertificateType.setState({ Data: verifications });
            }
          }
          else if(observer === "UploadConfirmation"){
            $("#LoadingIcon").removeClass().addClass('hide');
            if(this.ConfirmationsModel.UploadSuccess === true){
              Vas.GetView("CustomerVerifictaionUploadSuccess",{CustomerId:this.CustomerId},true);
            }else{
              ReactDOM.render(<MessageBox 
                AppURL={Vas.ApplicationUrl} 
                Message={Vas.Resources.ErrorMessages["UnexpectedError"]} 
                Title={Vas.Resources.Titles["Note"]} />
                  , document.getElementById('messageContainer'));
            }
          }
        });
    }

    Cancel(){
        this.props.me.setState({ Upload:false });
    }

    Close(){
        Vas.GetView("CustomerCard",{Id:this.CustomerId},true);
    }

    storeFile(event){
      if( event.target.files[0]){
        let type = event.target.files[0].type;
        if (((type.slice(0,5) === "image") || (type === "application/pdf")) && (event.target.files[0].size > 0) ){

          let maxFileSize = 10 * 1024 * 1000;

              if (event.target.files[0].size > maxFileSize){
                ReactDOM.render(<MessageBox 
                  AppURL={Vas.ApplicationUrl} 
                  Message={Vas.Resources.Labels["DocumentSizeInvalid"]} 
                  Title={Vas.Resources.Titles["Note"]} />
                    , document.getElementById('messageContainer'));

                    this.refs.FileText.setState({ Value:'', TextTooltip : '' });
                    this.setState({ filled:false });
              } else {

              let original = event.target.files[0].name;
              let name = event.target.files[0].name.split(".");

              if(name.length === 2){
                let length = name[0].length;
                let showName = name[0];
                let showType = "." + name[1];
                if(length > 20){
                showName = name[0].substr(0,19) + "...";
                }
                original = showName + showType;
              }
              if(this.UploadConfig.ShowStandardControl === false){
              this.refs.FileText.setState({ Value:original, TextTooltip : event.target.files[0].name });
              }
                this.setState({ files:event.target.files, fileName:event.target.files[0].name });
            } 
        }else{
          if(event.target.files[0].size === 0){
            ReactDOM.render(<MessageBox 
              AppURL={Vas.ApplicationUrl} 
              Message={Vas.Resources.Labels["FileNoContent"]} 
              Title={Vas.Resources.Titles["Note"]} />
                , document.getElementById('messageContainer'));
          }
        }
      }
        
    }

    getValues(){
        $("#CertificateStart").val("");
        $("#CertificateEnd").val("");
        $("#IDField").val("");

        let from = false;
        let to = false;
        let id = false;
        let maxAge = 0;
        let minAge = 0;

        if (this.props.order === true){
            for (let i = 0; i< this.keys.length; i++){
                if (this.props.field.Name === this.keys[i][1]){

                    from = this.keys[i][2];
                    to = this.keys[i][3];
                    id = this.keys[i][4];
                    minAge = this.keys[i][6];
                    maxAge = this.keys[i][7];
                    
                }
            }
        } else {
            if (document.getElementById('CertificateType').selectedIndex > 0){
              
                from = this.keys[document.getElementById('CertificateType').selectedIndex-1][2];
                to = this.keys[document.getElementById('CertificateType').selectedIndex-1][3];
                id = this.keys[document.getElementById('CertificateType').selectedIndex-1][4];
                minAge = this.keys[document.getElementById('CertificateType').selectedIndex-1][6];
                maxAge = this.keys[document.getElementById('CertificateType').selectedIndex-1][7];
            }
        }
        
        
        let requiredFields = [];
        if(this.UploadConfig.ShowStandardControl === false){
        requiredFields.push(this.refs.FileText);
        }
        if (from === true){
            requiredFields.push(this.refs.CertificateStart);
        }
        if (to === true){
          if(this.state.CertificationType){
            if(this.state.CertificationType === "vsl. Ende der Ausbildung"){
              requiredFields.push(this.refs.CertificateEnd);
            }
          }
            
        }
        if (id === true){
            requiredFields.push(this.refs.IDField);
        }
        //if(this.state.from !== from && this.state.to !== to && this.state.requiredFields !== requiredFields){
        let maxValue = null;

        if(this.keys[document.getElementById('CertificateType').selectedIndex-1] != undefined 
          && this.keys[document.getElementById('CertificateType').selectedIndex-1][1].indexOf("Ermäßigung") > -1){
          $("#DownloadButton").removeClass().addClass('visible');
              maxValue = moment().add(1,'year');
              if(this.refs.CertificateEnd){
                this.refs.CertificateEnd.setState({ShowDay : false});
              }
              
        }else{
          $("#DownloadButton").removeClass().addClass('hidden');
          if(this.refs.CertificateEnd){
            this.refs.CertificateEnd.setState({ShowDay : true});
          }
          
        }
        
        if(this.refs.CertificateEnd){
          this.refs.CertificateEnd.setState({MaxValue:maxValue});
        }
        let validTo = <div></div>;
            
        if(this.state.CertificationType){
          let minValue = moment();
          let countYears = 10 ;
          let maxValue = null;
          let years= [];
          let startYear = minValue.year();
          let varTo = 1;
          if(maxAge > 0){
            if(this.state.CertificationType.split(",")[1] === "vsl. Ende der Ausbildung" ){
              varTo = 2;
              if(this.CustomerModel.Customer.DateOfBirth.length > 0){
                let age = moment().diff(DateTimeHelper.StringToDate(this.CustomerModel.Customer.DateOfBirth,true,localStorage.getItem("vas_language")),'years');
                countYears = maxAge >= age ? maxAge-age : 0;
                maxValue = DateTimeHelper.StringToDate(this.CustomerModel.Customer.DateOfBirth,true,localStorage.getItem("vas_language")).add(maxAge,'years');
              }
            }else if(this.state.CertificationType.split(",")[1].indexOf("Ermäßigung") > -1){
              varTo = 2;
              countYears = 1 ;
              if(minValue.month() > 0){
                countYears = 2;
              }
              let maxValue = null;
              if(this.CustomerModel.Customer.DateOfBirth.length > 0){
                
                let age = moment().diff(DateTimeHelper.StringToDate(this.CustomerModel.Customer.DateOfBirth,true,localStorage.getItem("vas_language")),'years');
                //countYears = maxAge >= age ? maxAge-age : 0;
                maxValue = DateTimeHelper.StringToDate(this.CustomerModel.Customer.DateOfBirth,true,localStorage.getItem("vas_language")).add(maxAge,'years');
                if(maxValue.year() === minValue.year()){
                  countYears = 1;

                }else{
                  if(maxValue.isAfter(moment([minValue.year() + 1,minValue.month(),minValue.date()]))){
                    maxValue = moment([minValue.year() + 1,minValue.month()-1,minValue.date()]);
                   }
                }}
            }else{
              if(this.CustomerModel.Customer.DateOfBirth.length > 0){
                let age = moment().diff(DateTimeHelper.StringToDate(this.CustomerModel.Customer.DateOfBirth,true,localStorage.getItem("vas_language")),'years');
                countYears = maxAge >= age ? maxAge-age : 0;
                maxValue = DateTimeHelper.StringToDate(this.CustomerModel.Customer.DateOfBirth,true,localStorage.getItem("vas_language")).add(maxAge,'years').subtract(1,"day");
              }
            }
          }else{
            if(this.state.CertificationType.split(",")[1].indexOf("Ermäßigung") > -1){
              varTo = 2;
                countYears = 1;
                if(minValue.month() > 0){
                  countYears = 2;
                }
            }else if(this.state.CertificationType.split(",")[1] === "vsl. Ende der Ausbildung"){
              varTo = 2;
            }else{

            }
          }
          for(let i = 0; i<countYears; i++){
            years.push({Display:startYear + i, Key: startYear + i});
          }
          if(varTo === 1){
           validTo= (<DateField
              AppURL={Vas.ApplicationUrl}
              Language={localStorage.getItem("vas_language")}
              Width={170}
              Editable={true}
              Float={"left"}
              IsRequired={true}
              Id={"CertificateEnd"}
              Label={Vas.Resources.Labels["ValidTo"]+ '*'}
              OnBlur={()=>{ 
                if(this.keys[document.getElementById('CertificateType').selectedIndex-1][1] === "Ermäßigung"){
                  let curDate = DateTimeHelper.StringToDate($("#CertificateEnd").val(),false,localStorage.getItem('vas_language'),false);
                  curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                  curDate = DateTimeHelper.FormatToShortDateString(curDate);
                  
                  this.setState({ CertificateEnd: curDate });
                }else{
                  this.setState({ CertificateEnd: $("#CertificateEnd").val() });}}
                }
                
              MinValue={moment()}
              MaxValue={maxValue}
              
              />);
          }
          else if(varTo === 2){
            validTo=
            (<div>
                  <table>
                  <tbody>
                    <tr>
                      <td>
                        <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["ValidTo"]}</div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <SelectField
                        
                          Id={"VerificationYear"} 
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          IsRequired={true}
                          Label={Vas.Resources.Labels["Year"]+ "*"}
                          Data={ years}
                          OnChange={()=>{
                            this.setState({VerificationYear:$("#VerificationYear").val()},()=>{
                              if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                                let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                                curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                                curDate = DateTimeHelper.FormatToShortDateString(curDate);
                                
                                this.setState({ CertificateEnd: curDate });
                                
                              }
                            });
                            this.VerificationMonthRef.current.setState({Data:this.setVerificationMonths(minValue,maxValue)});
                          }}
                        />
                      </td>
                      <td>
                        <SelectField
                          Id={"VerificationMonth"} 
                          AppURL={Vas.ApplicationUrl}
                          me={this}
                          IsRequired={true}
                          Label={Vas.Resources.Labels["Month"]+ "*"}
                          ref={this.VerificationMonthRef}
                          Data = {this.setVerificationMonths(moment())}
                          OnChange={()=>{
                            this.setState({VerificationMonth:$("#VerificationMonth").val()},()=>{
                              if(document.getElementById('VerificationYear').selectedIndex > 0 && document.getElementById('VerificationMonth').selectedIndex > 0){
                                let curDate = moment([this.state.VerificationYear,this.state.VerificationMonth,1]);
                                curDate.date(DateTimeHelper.GetLastDayOfMonth(curDate.month(),curDate.year()));
                                curDate = DateTimeHelper.FormatToShortDateString(curDate);
                                
                                this.setState({ CertificateEnd: curDate });
                                
                              }
                            });
                          }}
                        />
                      </td>
                    </tr>
                    
                  </tbody>
                </table>
                </div>);
          }
          
          
          this.setState({ 
                from:from, 
                to:to, 
                id:id,
                maxAge : maxAge,
                minAge : minAge, 
                requiredFields:requiredFields,
                files:null, fileName:'', 
                description: this.keys[document.getElementById('CertificateType').selectedIndex-1] == undefined 
                  ? '' 
                  : this.keys[document.getElementById('CertificateType').selectedIndex-1][5] });    
      } 
          //ReactDOM.unmountComponentAtNode(document.getElementById("TdTo"));
         ReactDOM.render(
           validTo
          ,document.getElementById("TdTo"));
         
        //}
             
    }

    checkFields(){
        if (this.state.requiredFields&& this.state.requiredSelectField){
            let count=this.state.requiredFields.length+ this.state.requiredSelectField.length;
                       
            let filled = 0;

            for (let i = 0;i < this.state.requiredFields.length;i++){
                if (this.state.requiredFields[i]){
                    if (document.getElementById(this.state.requiredFields[i].props.Id).value.length > 0){
                            filled++;
                    }
                }
            }

            for (let k=0; k<this.state.requiredSelectField.length;k++){
                if (this.state.requiredSelectField[k]){
                  if (document.getElementById(this.state.requiredSelectField[k].props.Id).selectedIndex >0){
                    filled++;
                  }
                }
              }

            
            if(this.state.CertificationType){
              if(this.state.CertificationType.split(",")[1] === "vsl. Ende der Ausbildung"){
                count++;
                if(this.state.CertificateEnd){
                  filled++;
                }
              }
            }

            if (filled < count){
                let docs=document.querySelectorAll('select,input');
                let docRefs = this.refs;
                CheckValues.checkAllFields(docs,docRefs,"");
                ReactDOM.render(<MessageBox
                  Message={Vas.Resources.Labels["NotAllFields"]}
                  Title={Vas.Resources.Titles["Note"]} />,document.getElementById('messageContainer'));
                return false;
            } else {
                return true;
            }
        } else {
            let docs=document.querySelectorAll('select,input');
            let docRefs = this.refs;
            CheckValues.checkAllFields(docs,docRefs,"");
            ReactDOM.render(<MessageBox
              Message={Vas.Resources.Labels["NotAllFields"]}
              Title={Vas.Resources.Titles["Note"]} />,document.getElementById('messageContainer'));
            return false;
        }
    }

    setVerificationMonths(minValue,maxValue){
      let monthsArr = [Vas.Resources.Calendar["January"],Vas.Resources.Calendar["February"],Vas.Resources.Calendar["March"],Vas.Resources.Calendar["April"],
        Vas.Resources.Calendar["May"],Vas.Resources.Calendar["June"],Vas.Resources.Calendar["July"],Vas.Resources.Calendar["August"],
        Vas.Resources.Calendar["September"],Vas.Resources.Calendar["October"],Vas.Resources.Calendar["November"],Vas.Resources.Calendar["December"]];
      let months = [];
      if(document.getElementById('VerificationYear')){
        if(document.getElementById('VerificationYear').selectedIndex > 0){
          if(maxValue){
            let year = Number($("#VerificationYear").val());
            if(year === minValue.year()){
              let firstMonth = minValue.month();
              let count =monthsArr.length;
              if(year === maxValue.year()){
                count = maxValue.month()+1;
              }
              for(let i = firstMonth; i<count;i++){
                months.push({Display:monthsArr[i],Key:i});
              }
    
            }
            
            else if(year === maxValue.year()){
              let lastMonth = maxValue.month();
              for(let i = 0; i<=lastMonth;i++){
                months.push({Display:monthsArr[i],Key:i});
              }
            }
            
            else{
              for(let i = 0; i<monthsArr.length;i++){
                months.push({Display:monthsArr[i],Key:i});
              }
            }
          }else{
            let year = Number($("#VerificationYear").val());
            if(year === minValue.year()){
              let firstMonth = minValue.month();
              for(let i = firstMonth; i<monthsArr.length;i++){
                months.push({Display:monthsArr[i],Key:i});
              }
    
            }
            else{
              for(let i = 0; i<monthsArr.length;i++){
                months.push({Display:monthsArr[i],Key:i});
              }
            }
          }
          
        }else{
          for(let i = 0; i<monthsArr.length;i++){
            months.push({Display:monthsArr[i],Key:i});
          }
        }
      }else{
        for(let i = 0; i<monthsArr.length;i++){
          months.push({Display:monthsArr[i],Key:i});
        }
      }
      if(this.refs.VerificationMonth){
        this.refs.VerificationMonth.setState({Data:months});
      }
      return months;
    }

    LogoClick(){

      var kontrastNumber = localStorage.getItem('Kontrast');
  
      if(kontrastNumber == "true"){
        $('.verificationUploadForm').attr('style', 'border: 1px solid #1d5c87;');
        $('#FileText').attr('style', 'width: 300px; float: left; border-bottom: 1px dotted #1d5c87;');
        $('#CertificateType').attr('style', 'width: 340px; float: left; border-bottom: 1px dotted #1d5c87;');
        $('.verificationUploadForm #btoChoose').attr('style', 'background-color: #1d5c87; width: 150px; float: left;');
        $('.verificationUploadForm #btoFileUpload').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
        $('.verificationUploadForm #btoClose').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
      }
    }

    render()
    {
        if (this.state.from === false){
            $('#TdFrom').removeClass().addClass("tdNotVisible");
        } else {
            $('#TdFrom').removeClass().addClass("tdVisible");
        }

        if (this.state.to === false){
            $('#TdTo').removeClass().addClass("tdNotVisible");
        } else {
            $('#TdTo').removeClass().addClass("tdVisible");
        }
       
        if (this.state.id === false){
            $('#TdId').removeClass().addClass("tdNotVisible");
        } else {
            $('#TdId').removeClass().addClass("tdVisible");
        }
        
        if(this.state.description.length > 0){
          $('#TdDescription').removeClass().addClass("tdVisible");
        }else{
          $('#TdDescription').removeClass().addClass("tdNotVisible");
        }

        let type = '';
        if (this.props.order === true){
            type = (<td colSpan={2}><TextField
              AppURL={Vas.ApplicationUrl}
              ref={"CertificateType"}
              Width={340}
              Id="CertificateType"
              Value={this.props.field.Name}
              Editable={false}
              Label={Vas.Resources.Labels["CertificateType"]} /> </td>);
        } else {
            type = (<td colSpan={2}><SelectField
              AppURL={Vas.ApplicationUrl}
              Width={340}
              ref={"CertificateType"}
              Id={"CertificateType"}
              Editable={true}
              IsRequired={true}
              Label={Vas.Resources.Labels["ChooseCertificateType"]}
              OnChange={()=>{ this.setState({ CertificationType: $("#CertificateType").val() },()=>{this.getValues();});}} /></td>);
        }

        /*let mod = '';
        if (this.props.order === true){
            mod = false;
        } else {
            mod = true;
        }*/

        let btoChooseIcon = <ExtendedButton
        Id={"btoChoose"}
        Usable={true}
        Text={<Icon  
          Name={"Upload"} 
          Size={18} 
          Color={"black"} 
          PaddingLeft={'6px'} 
          PaddingTop={'0px'} 
          Tooltip={Vas.Resources.Tooltips["ChooseDocument"]}
          OnClick={()=>{$("#fileUpload").trigger('click');}}
           />}
        Width={30}
        Height={30}
        Type={"Round"} />;

        if(Vas.isIE) {
          btoChooseIcon = <ExtendedButton
            Id={"btoChoose"}
            Usable={true}
            Text={<Icon  
            Name={"Upload"} 
            Size={18} 
            Color={"black"} 
            PaddingLeft={'6px'} 
            PaddingTop={'0px'} 
            Tooltip={Vas.Resources.Tooltips["ChooseDocument"]}/>}
            Width={30}
            Height={30}
            Type={"Round"} />;
        }
      
      let btoChooseText = "";
      if(this.IconConfig.ShowIcons === false){
        btoChooseIcon="";
        btoChooseText = <ExtendedButton
          Id={"btoChoose"}
          Usable={true}
          Text={Vas.Resources.Labels["ChooseDocument"]}
          Width={150}
          Float={"left"}
          OnClick={()=>{$("#fileUpload").trigger('click');}} />;

          if(Vas.isIE) {
            btoChooseText = <ExtendedButton
              Id={"btoChoose"}
              Usable={true}
              Text={Vas.Resources.Labels["ChooseDocument"]}
              Width={150}
              Float={"left"}/>;
          }
      }

      let classNameStandartControl = "standartInput";
      let additionTextField = <td></td>;
      let additionButton = <td></td>;

      if(this.UploadConfig.ShowStandardControl === false){
        classNameStandartControl = "inputfile";
        additionTextField = <td>
        <TextField
          AppURL={Vas.ApplicationUrl}
          ref={"FileText"}
          Width={300}
          Id="FileText"
          Value={this.state.fileName}
          Editable={false}
          Float={"left"}
          Label={Vas.Resources.Labels["File"]+ '*'}
          OnBlur={()=>{ this.setState({ IdentificationNumber: $("#IdentificationNumber").val() });}} />
      </td>
        additionButton = <td colSpan={2}>
        <label htmlFor="fileUpload">
            {btoChooseText}
            
            </label>
        </td>
      }
        return (
        <div className={"form verificationUploadForm"}>
            <table>
                <thead>
                    <tr>
                        <th style={{width:"360px"}}>{Vas.Resources.Titles["UploadVerification"]}</th>
                        <th><div
                          id={"LoadingIcon"}
                          className={'hide'}></div></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className={"ConfirmationLabel"} style={{float:'left'}}><br />{Vas.Resources.Labels["RequiredField"]}</td>
                    </tr>
                </tbody>
            </table>
            <table>
                <tbody>
                    <tr>
                        {type} 
                    </tr>
                    <tr>
                      <td id={"TdDescription"} className={"tdNotVisible"}>
                          <div style={{width:'340px',textAlign:'left'}}><b>{Vas.Resources.Titles["Note"]}: </b><i>{this.state.description}</i></div></td>
                    </tr>
                </tbody>
            </table>
            <br />
            <div id={"DownloadButton"} style={{ marginTop: '-20px', marginBottom: '92px' }} className={"hidden"}>
              <ExtendedButton
                Id={"DownloadDocument"}
                Usable={true}
                Text={ Vas.Resources.Labels["ReductionDocumentDownload"] }
                Width={170}
                Float={"left"}
                OnClick={() => { window.open(Vas.ApplicationUrl+"/ErmäßigungABO.pdf") }} />
            </div>
            <table>
              <tbody>     
                <tr>
                  <td className={"btoTd"}>
                    <input
                      id="fileUpload"
                      type="file"
                      name="files[]"
                      className={classNameStandartControl}
                      onChange={(event)=>{this.storeFile(event);}}
                      accept="image/bmp,image/png,image/jpeg,image/jpg, image/gif,application/pdf" />
                    <label htmlFor="fileUpload">{btoChooseIcon}</label>
                  </td>
                  {additionTextField}
                  
                </tr>
                <tr>
                  {additionButton}
                
              </tr>
                <tr>
                  <td colSpan={2}>
                    <div id={"verificationUploadHintContainer"}>
                      <br />
                      {Vas.Resources.Labels["ValidDocumentFormat"]}
                      <br /><br />
                      {Vas.Resources.Labels["ValidDocumentSize"]}
                    </div>
                   </td>
                </tr>
                
                
              </tbody>
            </table>
            <table>
              <tbody>
                <tr>
                  <td id={"TdFrom"} className={"tdNotVisible"}>
                      <div><DateField
                      AppURL={Vas.ApplicationUrl}
                      Language={localStorage.getItem("vas_language")}
                      ref={"CertificateStart"}
                      Width={170}
                      Editable={true}
                      IsRequired={true}
                      Id={"CertificateStart"}
                      Label={Vas.Resources.Labels["ValidFrom"]+ '*'}
                      OnBlur={()=>{ this.setState({ CertificateStart: $("#CertificateStart").val() });}} 
                      MinValue={moment()}
                      /></div></td>
                  
                </tr>
                <tr>
                <td id={"TdTo"} className={"tdNotVisible"} colSpan={2}></td>
                </tr>
                <tr>
                  <td id={"TdId"} className={"tdNotVisible"} colSpan={2}>
                    <div><TextField
                        AppURL={Vas.ApplicationUrl}
                        ref={"IDField"}
                        Width={335}
                        Id="IDField"
                        Editable={true}
                        IsRequired={true}
                        Label={Vas.Resources.Labels["IdentificationNumber"]+ '*'}
                        OnBlur={()=>{ this.setState({ IdentificationNumber: $("#IDField").val() });}} /></div>
                  </td>
                </tr>
                <tr>
                  <td >
                    <br />
                    <ExtendedButton
                      Id={"btoFileUpload"}
                      Usable={true}
                      ref={"btoDone"}
                      Text={Vas.Resources.Labels["UploadCertificate"]}
                      Float={'left'}
                      OnClick={()=>{ this.FileUpload();}}
                      Width={170}/>
                  </td>
                  <td>   
                    <br />
                    <ExtendedButton
                      Id={"btoClose"}
                      Usable={true}
                      Text={Vas.Resources.Labels["Cancel"]}
                      Float={'left'}
                      OnClick={()=>{ this.Close();}}
                      Width={170}/>
                  </td>
                </tr>
              </tbody>
            </table>
        </div>
        );

    }
}
export default VerificationUpload;
